import React, { useEffect, useRef, useState } from "react";
import "./Dino.css";

function Dino() {
  const dinoRef = useRef();
  const cactusRef = useRef();
  const floorRef = useRef(); // Add ref for the floor
  const [score, setScore] = useState(0);
  const [isRunning, setIsRunning] = useState(false); // State to control game running
  const [isJumping, setIsJumping] = useState(false); // State to track jumping

  const handleStartGame = () => {
    if(isRunning){
      jump();
    } else {
      setIsRunning(true); // Start the game
    }
  };

  const jump = () => {
    if (!isRunning) return; // Do nothing if game isn't running

    setIsJumping(true);
    if (!!dinoRef.current && !dinoRef.current.classList.contains("jump")) {
      dinoRef.current.classList.add("jump");
      setTimeout(function () {
        dinoRef.current.classList.remove("jump");
        setIsJumping(false);
      }, 300);
    }
  };

  useEffect(() => {
    const isAlive = setInterval(function () {
      if (!isRunning) return; // Do nothing if game isn't running

      const dinoTop = parseInt(
        getComputedStyle(dinoRef.current).getPropertyValue("top")
      );
      let cactusLeft = parseInt(
        getComputedStyle(cactusRef.current).getPropertyValue("left")
      );

      if (cactusLeft < 40 && cactusLeft > 0 && dinoTop >= 140) {
        // Game Over
        setIsRunning(false); // Stop the game
        setScore(0);
      } else {
        setScore((prevScore) => prevScore + 1);
      }
    }, 10);

    return () => clearInterval(isAlive);
  }, [isRunning]);

  useEffect(() => {
    document.addEventListener("keydown", jump);
    return () => document.removeEventListener("keydown", jump);
  }, [isRunning]);

  // Randomize cactus class every 1 second
  useEffect(() => {
    const interval = setInterval(() => {
      if (isRunning) {
        const randomClass = `cactus-${Math.floor(Math.random() * 5) + 1}`;
        cactusRef.current.className = randomClass;
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning]);

  // Animation effect for dino walking
  useEffect(() => {
    let walkingInterval;
    if (isRunning && !isJumping) {
      walkingInterval = setInterval(() => {
        if (dinoRef.current.classList.contains("dino-state-1")) {
          dinoRef.current.classList.remove("dino-state-1");
          dinoRef.current.classList.add("dino-state-2");
        } else {
          dinoRef.current.classList.remove("dino-state-2");
          dinoRef.current.classList.add("dino-state-1");
        }
      }, 100); // Adjust the interval to change the walking speed
    } else {
      clearInterval(walkingInterval);
      dinoRef.current.classList.remove("dino-state-1", "dino-state-2");
      dinoRef.current.classList.add("dino-state-0");
    }

    return () => clearInterval(walkingInterval);
  }, [isRunning, isJumping]);

  return (
    <div className="dinogame" onClick={handleStartGame}>
      {!isRunning && <div className="start-message mt-4 text-center">Lets Play Dino! Click to Start...</div>}
      {isRunning && <div className="ml-5 mt-4">Score : {score}</div>}
      <div className="sun" style={{background: isRunning ? "#545454" : "#272727"}} />
      <div id="dino" className="dino-state-0" ref={dinoRef}></div> {/* Change the dino state according the condition of dino: when game no running 0, when jumping 3 else when running quickly switch between 2 amd 1 continuously to give walking effect */}
      <div id="cactus" className={isRunning ? "cactus-1" : "hidden"} ref={cactusRef}></div>
      <div id="floor" ref={floorRef}></div> {/* Floor element */}
    </div>
  );
}

export default Dino;
